import { factory } from './model/model';
import { SurveyForm as Form } from './ui/Form';

export const SurveyForm = {
  Form,
  factory,
};
